<template>
  <div id="app">
    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title>{{$t('Definitions-v2')}}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-flex>
      </v-layout>

      <v-container fluid>
        <v-layout row wrap>
          <router-link :to="{ name: 'muhasebe-tanimlamalar-sirkettanitim' }">
            <v-btn style="width: 200px" color="info" dark>{{ $t('Companies') }} </v-btn>
          </router-link>
          <router-link :to="{ name: 'muhasebe-tanimlamalar-merkeztanitim' }">
            <v-btn style="width: 200px" color="info" dark> {{ $t('CENTER') }}  </v-btn>
          </router-link>
          <router-link :to="{ name: 'muhasebe-tanimlamalar-fistipitanitim' }">
            <v-btn style="width: 200px" color="info" dark> {{ $t('Bill-Type') }}  </v-btn>
          </router-link>
        
        </v-layout>
      </v-container>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "muhasebe-tanimlamalar",
  data() {
    return {};
  },
};
</script>

<style>
</style>